
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/spotlight-damien-tassone",
      function () {
        return require("private-next-pages/blog/spotlight-damien-tassone.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/spotlight-damien-tassone"])
      });
    }
  